var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-btn',{staticClass:"d-flex align-items-center mt-3",attrs:{"button":"","variant":"light","block":"","pill":""},on:{"click":_vm.emailSupport}},[_c('div',{staticClass:"mr-2"},[_c('font-awesome-icon',{staticClass:"small-avatar branded",attrs:{"icon":"fa-duotone fa-circle-question","size":"lg"}})],1),_vm._v(" Contact Support ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }